import { render, staticRenderFns } from "./Tor10.vue?vue&type=template&id=d2a617ec&"
import script from "./Tor10.vue?vue&type=script&lang=js&"
export * from "./Tor10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports